import { render, staticRenderFns } from "./dangerousDetail.vue?vue&type=template&id=1390ee32&scoped=true"
import script from "./dangerousDetail.vue?vue&type=script&lang=js"
export * from "./dangerousDetail.vue?vue&type=script&lang=js"
import style0 from "./dangerousDetail.vue?vue&type=style&index=0&id=1390ee32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1390ee32",
  null
  
)

export default component.exports